import { apiFetch } from './client.ts';
import type { Unlock } from '@ricochet/achievements';

export interface EndlessSolveResponse {
  id: string;
  numberOfMoves: number;
  createdAt: string;
  unlockedAchievements?: Unlock[];
}

export function submitEndlessSolve(
  data: {
    puzzleCompact: string;
    moveSequence: string;
    numberOfMoves: number;
    difficulty: number;
    gridSize: number;
    numTargets: number;
  },
  token: string,
): Promise<EndlessSolveResponse> {
  return apiFetch('/api/endless/solves', { method: 'POST', body: data, token });
}
